(function() {
  try {
    if (window.location.pathname.includes('/products/')) {
      const handle = window.location.pathname.split('/').pop();
      let viewed = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
      // Remove if exists to move to top
      viewed = viewed.filter(h => h !== handle);
      // Add to top
      viewed.unshift(handle);
      // Limit to 10
      viewed = viewed.slice(0, 10);
      localStorage.setItem('recently_viewed', JSON.stringify(viewed));
    }
  } catch (e) {
    console.error('Error updating recently viewed:', e);
  }
})();
